import React from 'react';
import './ProgressIndicator.css';

const ProgressIndicator = ({ text }) => (
    <div
        className="al-loading"
        role="status"
        aria-live="polite"
        aria-busy="true"
    >
        <div className="al-loading-dots" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
        </div>
        {text ? (
            <p className="al-loading-text">{text}</p>
        ) : (
            <span className="al-sr-only">Loading...</span>
        )}
    </div>
);

export default ProgressIndicator;
